"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero-section" className="relative w-full min-h-[400px] md:min-h-[500px] lg:min-h-[600px] flex items-center bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_field_hero_bg.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_field_hero_bg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_field_hero_bg.png-wvc-sizes" alt="Beautiful lavender field in bloom" className="w-full h-full object-cover object-center" loading="lazy" decoding="async" />
        {}
        <div className="absolute inset-0 bg-background/40 sm:bg-gradient-to-r sm:from-background/80 sm:via-background/40 sm:to-transparent"></div>
      </div>

      {}
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={ref} className={`max-w-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-default text-foreground mb-6 lowercase tracking-tight">
            Get In Touch
          </h1>
          <p className="text-lg md:text-xl text-foreground/90 font-default leading-relaxed max-w-lg">
            Let us answer any questions you may have, or let us know how we can help you.
          </p>
        </div>
      </div>
    </section>;
}